import { makeAutoObservable, runInAction } from 'mobx';

import ApiService from 'src/services/ApiService';
import { STORE_NAME } from 'src/utils/constants';
import { handleStateError } from 'src/errors';
import { HealthGoal } from 'src/models/health-goals/HealthGoal';
import { MemberGoalCompletedResult } from 'src/models/health-goals/MemberGoalCompletedResult';
import { MemberGoalResult } from 'src/models/health-goals/MemberGoalResult';
import { compareHealthGoals, extractPinnedGoals } from 'src/utils/healthGoalsUtils';
import { RootStore } from './RootStore';

export default class HealthGoalsStore {
  private static storeName = STORE_NAME.HEALTH_GOALS_STORE;
  private rootStore: RootStore;
  private apiService: ApiService;

  public healthGoal?: HealthGoal;
  public pinnedHealthGoals: (MemberGoalCompletedResult | MemberGoalResult)[] = [];

  constructor(rootStore: RootStore, apiService?: ApiService) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.apiService = apiService || new ApiService(this.rootStore.authStore.getWhsAccessToken);
  }

  getHealthGoals = async (): Promise<HealthGoal | undefined> => {
    try {
      const healthGoal = await this.apiService.getHealthGoals();

      const pinnedHealthGoals = extractPinnedGoals(healthGoal).sort(compareHealthGoals);

      if (healthGoal) {
        runInAction(() => {
          this.healthGoal = healthGoal;
          this.pinnedHealthGoals = pinnedHealthGoals;
        });
      }

      return this.healthGoal;
    }
    catch (error) {
      handleStateError(error, HealthGoalsStore.storeName);
    }
  };
}
